import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'FormComponent',
  props: ['component'],
  setup(__props) {

    

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "children")
}
}

})